<nav aria-label="breadcrumb" *ngIf="!isMarket">
  <a [routerLink]="['/documents']">Accueil</a> <mat-icon>arrow_right</mat-icon> 
  <a [routerLink]="['/documents/' + typeSupport.marketId]">Marché</a> <mat-icon>arrow_right</mat-icon>
  <span>Édition d'un type de support</span>
</nav>

<nav aria-label="breadcrumb" *ngIf="isMarket">
  <a [routerLink]="['/documents']">Accueil</a> <mat-icon>arrow_right</mat-icon>
  <a [routerLink]="['/documents/' + typeSupport.marketId]">Marché</a> <mat-icon>arrow_right</mat-icon>
  <span>Création d'un type de support</span>
</nav>

<mat-card>
  <mat-label>Nom*</mat-label>
  <mat-form-field class="nom-market">
    <input class="nom-market" matInput [(ngModel)]="typeSupport.name" maxlength="100">
  </mat-form-field>

  <mat-divider></mat-divider>
  <mat-label>Icône*</mat-label>
  <mat-card-content fxLayout="row">
    <div *ngFor="let img of listImg">
      <img [ngClass]="imgSelected === img ? 'selected' : ''" (click)="selectedIcon(img)" src="assets/icons/{{img}}" alt="homepage" width="60" height="60">
    </div>
  </mat-card-content>
  
  <mat-divider></mat-divider>
  <mat-card-footer fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button color="primary" [ngClass]="!typeSupport.name || !typeSupport.icon ? '' : 'primary-button'" (click)="updateTypeSupport()" aria-label="Enregistrer" 
    [disabled]="!typeSupport.name || !typeSupport.icon">Enregistrer</button>
  </mat-card-footer>
</mat-card>
  
